// extracted by mini-css-extract-plugin
export default {"image":"CommentContext-module__image--q8AML","highlight":"CommentContext-module__highlight--cig7V"};